"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var classnames_1 = __importDefault(require("classnames"));

var react_bootstrap_1 = require("react-bootstrap");

require("./SzRadio.scss");

function SzRadio(props) {
  var children = props.children,
      value = props.value,
      className = props.className,
      checked = props.checked,
      onChange = props.onChange,
      id = props.id,
      name = props.name;
  var containerClass = classnames_1.default('d-flex align-items-center p-2 sz-radio', className);
  return react_1.default.createElement("div", {
    className: containerClass
  }, react_1.default.createElement(react_bootstrap_1.Form.Check, {
    custom: true,
    type: "radio"
  }, react_1.default.createElement(react_bootstrap_1.Form.Check.Label, {
    className: "d-flex align-items-center"
  }, react_1.default.createElement(react_bootstrap_1.Form.Check.Input, {
    name: name,
    id: id,
    type: 'radio',
    checked: checked,
    value: value,
    onChange: onChange
  }), children)));
}

exports.default = SzRadio;
SzRadio.propTypes = {
  value: prop_types_1.default.string,
  className: prop_types_1.default.string,
  children: prop_types_1.default.any,
  checked: prop_types_1.default.bool,
  onChange: prop_types_1.default.func,
  id: prop_types_1.default.string
};